import React from 'react';
import { NumericFormat } from 'react-number-format';
import { onPaste } from '../../../utils/segments';
import styles from '../Contacts.module.scss';

const InputNumber = ({ label, getter, setter }) => {
  const handleChange = (newValue) => {
    if (!newValue || newValue === '0') {
      setter('');
    } else {
      setter(newValue);
    }
  };
  return (
    <div className={styles.filter_row}>
      <span className={styles.label}>{label}</span>
      <NumericFormat
        className={`form-control ${styles.input} w-100`}
        thousandSeparator
        prefix="$"
        allowNegative={false}
        onPaste={onPaste}
        placeholder="Input a value"
        onValueChange={(values) => {
          const { value: newVal } = values;
          handleChange(newVal);
        }}
        onBlur={(e) => e.target.blur()}
        isAllowed={(values) => {
          const { floatValue, formattedValue } = values;
          return Number.isInteger(floatValue) || formattedValue === '';
        }}
        valueIsNumericString
        value={getter}
      />
    </div>
  );
};

export default InputNumber;
